import { WorkingPlatform } from '@repo/platform';

export const COMMON_UI_HIDDEN_PARTNERS: WorkingPlatform[] = ['kbank', 'joins-hr'];
export const ADS_HIDDEN_PARTNERS: WorkingPlatform[] = ['joins-hr'];
export const CONTENTS_FILTER_PARTNERS: WorkingPlatform[] = ['joins-hr'];
export const CONTENT_CATEGORY_HIDDEN_PARTNERS: WorkingPlatform[] = ['joins-hr'];
export const CONTENT_CATEGORY_EXCLUDED_NAMES = ['법인관리'] as const;

export const MAINTENANCE_PATH = '/system-maintenance';
export const MAINTENANCE_ALLOWED_PATHS = [MAINTENANCE_PATH];
export const MAINTENANCE_SETTINGS_URL = 'https://firebasestorage.googleapis.com/v0/b/em-bznav.appspot.com/o/bznav-sena%2Fmaintenance-setting.json?alt=media';

export const DEFAULT_PAGE_TITLE = '비즈넵 세나 - 무료로 언제든 세무, 법률, 노무 상담이 가능한 비즈넵 AI';
export const DEFAULT_PAGE_DESCRIPTION =
  '세무, 법률, 노무와 관련한 어떤 질문이든 편하게 물어보세요. AI의 빠른 답변과 전문가들의 꼼꼼한 검증으로 엄선된 지식 콘텐츠를 만나보세요.';
export const DEFAULT_OPEN_GRAPH_IMAGE = new URL('/logos/bznav-sena-thumbnail.png', process.env.NEXT_PUBLIC_SERVICE_DOMAIN);
